import React from 'react';

class SDGGoalsDescription extends React.PureComponent {
  render() {
    return (
      <div className={ this.props.className }>
        <h3>Goal 16: Peace, justice and strong institutions</h3>
        <p>
          “Promote peaceful and inclusive societies for sustainable
          development, provide access to justice for all and build effective,
          accountable and inclusive institutions at all levels.”{' '}
        </p>

        <h4>Target 16.4 </h4>
        <p>
          [By 2030, significantly reduce illicit financial and arms flows,
          strengthen the recovery and return of stolen assets and combat all
          forms of organized crime].
        </p>

        <h4>Indicator 16.4.2: </h4>
        <p>
          “Proportion of seized, found or surrendered arms, whose illicit
          origin or context has been traced or established by a competent
          authority in line with international instruments”, UNODC and UNODA.{' '}
        </p>

        <h4>Indicator 16.4.3 (proposed):</h4>
        <p>
          “Number and percentage of seized, found or surrendered small arms and light weapons that have been marked and recorded, or destroyed in accordance with relevant international instruments, to prevent diversion into illicit flows”, UNODA
        </p>
      </div>
    );
  }
}

export default SDGGoalsDescription;




// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGGoalsDescription.js